import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PortfolioService } from '../portfolio.service';
import { Observable } from 'rxjs';
import { LoaderService } from '../../../../services/loader.service';
import { collapseTextChangeRangesAcrossMultipleVersions } from 'typescript';
declare var $:any;
@Component({
  selector: 'app-listportfoliodata',
  templateUrl: './listportfoliodata.component.html',
  styleUrls: ['./listportfoliodata.component.css'],
  providers: [PortfolioService]
})
export class ListportfoliodataComponent implements OnInit {

	portfolio: any[];
  public spaces = [];
  public segments = ['Home','Office'];
  public themes = [];
  public lifestages = [];
  public elements = [];
  private lifestageFlag = false;
  private elementsFlag = false;

  segment : string;
  theme : string;
  element : string;
  space : string;
  attachment_file : any;
  lifestage : string;
  price_cents: string;
  preset_number: any;
  space_area: any;
  space_shape: any;
  city: any;
  apartment_name: any;
  preset_type: any;
  format: any;
  variant_id: any;
  boq_value: any;
  boq_number: any;
  user_story_title: string;
  portfolio_data: any;
  description: string;
  imgsrc: string;
  secondaryImage: any;
  attachment_File: any;
  attachment_name: string;
  basefile = {};
  basefileSecondary = {};
  submitted = false;
  id: number;
  p:any;
  loader :boolean;
  errorMessage : string;
  erroralert = false;
  successalert = false;
  successMessage : string;
  search = '';
  city_list: any;
  current_page ;
  constructor(
  	private router: Router,
    private portfolioService:PortfolioService,
    private loaderService : LoaderService
  ) { }

  ngOnInit() {
    this.getpage("");
    this.getBOQvalues('');
    this.getCities();
    if(this.current_page == undefined){
      this.current_page =1;
    }
   
  }
  ngAfterViewInit() {
        $('[data-toggle="tooltip"]').tooltip();
  }

  portfolioListFromService(){
   
     this.portfolioService.getPortFolioList("",1,10).subscribe(
        res => {
          let portfolio = JSON.parse(res._body);
          this.total_page = portfolio.count;
          this.current_page = portfolio.page_number
           this.portfolio = portfolio.portfolios ;
           this.loaderService.display(false);
        },
        error =>  {
          this.erroralert = true;
          this.errorMessage = <any>JSON.parse(this.errorMessage['_body']).message;
          // $.notify(JSON.parse(this.errorMessage['_body']).message);
        }
    );
  }

  confirmAndDelete(id:number) {
    if (confirm("Are You Sure") == true) {
      this.DeletePortfolio(id);
    }
  }

  private DeletePortfolio(id:number){
    this.loaderService.display(true);
     this.portfolioService.deletePortfolio(id).subscribe(
        portfolio => {
          this.portfolioListFromService();
          this.successalert = true;
          this.successMessage = "Portfolio Deleted Successfully !!";
          $(window).scrollTop(0);
          setTimeout(function() {
                this.successalert = false;
            }.bind(this), 2000);

        //  $.notify('Deleted Successfully!');
          this.loaderService.display(false);
        },
        error =>  {
          this.erroralert = true;
          this.errorMessage = <any>JSON.parse(error['_body']).message;
          $(window).scrollTop(0);
          setTimeout(function() {
                this.erroralert = false;
            }.bind(this), 2000);
        //  $.notify(JSON.parse(this.errorMessage['_body']).message);
           this.loaderService.display(false);
        }
    );
  }

  space_item: any = [];
  finalid: any;
  varientIdimage: any;
  unidImage: any;
  search_word: any  = ' ';
  private getPortfolio(id: number) {
    
    this.finalid = id;
    this.portfolioService.viewPortfolioData(id).subscribe(
      res => {
        this.segment = res.portfolio.segment;
        this.imgsrc = res.portfolio.attachment_file;
        this.secondaryImage = res.portfolio.contents;
        this.firstDropDownChanged(this.segment);
        this.element = res.portfolio.element;
        this.space = res.portfolio.space;
        this.spaceDropDownChanged(this.space);
        this.theme = res.portfolio.theme;
        this.lifestage = res.portfolio.lifestage;
        
        this.price_cents = res.portfolio.price_cents;
        this.preset_number = res.portfolio.preset_number;
        this.space_area = res.portfolio.space_area;
        this.space_shape = res.portfolio.space_shape;
        if (res.portfolio.apartment.length === 0) {
          this.city = '';
          this.apartment_name = '';
          this.format = '';
          this.variant_id = '';
        }
        else {
          this.city = res.portfolio.apartment[0].city;
          this.apartment_name = res.portfolio.apartment[0].apartment_name;
          this.format = res.portfolio.apartment[0].format;
          this.variant_id = res.portfolio.apartment[0].variant_id;
          this.varientIdimage = res.portfolio.apartment[0].id;
        }
        this.preset_type = res.portfolio.preset_type;
        this.description = res.portfolio.description;
        this.boq_number = res.portfolio.boq_number;
        this.boq_value = res.portfolio.boq_value;
        this.user_story_title = res.portfolio.user_story_title
        this.portfolio_data = (res.portfolio.portfolio_data != null) ? JSON.stringify(res.portfolio.portfolio_data) : 'NA';
        this.space_item = res.portfolio.space_items;
        // this.attachment_file = res.portfolio.attachment_file;
        this.getLifeSatgeData();
        this.societySearch(this.city, '');
        for (let i = 0; i < this.space_item.length; i++) {
          this.selected_space_item.push(
            this.space_item[i].id
          )
        }
        
        // this.getLifeSatgeData();
        this.getSpaceItems(this.space);
      },
      error => {
          
      }

    );
    
  }
  /*-- edit portfolio methods -- */

  firstDropDownChanged(val: any) {
    if (val == "Home") {
      this.space ='';
      this.spaces = ["Kitchen", "Bedroom", "Living", "Kids Room","Master Bedroom","Guest Bedroom"," Dining Room","All Spaces"];
      this.themes = ['All','Minimalist','Transitional','Contemporary','Modern','Rustic Industrial','Indian Ethnic','Other'];
      this.elements = ['Master Bedroom','Kids Room', 'Wardrobe'];
      // this.lifestages = ['Bachelor','Working Couple','Large Families','Old Age'];
    }
    else if (val == "Office") {
      this.space ='';
      this.spaces = ["Conference", "Reception", "Workstations"];
      this.themes = ['Minimalist','Transitional','Contemporary','Modern','Rustic Industrial','Other'];
      this.lifestages = [];
      this.elements = [];
    }
    else {
      this.spaces = [];
      this.themes = [];
      this.elements = [];
      this.lifestages = [];
    }
  }

  spaceDropDownChanged(val: any) {
    if (val == 'Kitchen'){
      // this.lifestages = ['Bachelor','Working Couple','Large Families','Old Age'];
      this.themes = ['Minimalist','Transitional','Contemporary','Modern','Rustic Industrial','Other','Lifestage Kitchen'];
      this.element='';
      this.theme = "";
      this.lifestageFlag = true;
      this.elementsFlag = false;
    }
    else if (val == 'Bedroom') {
      this.lifestage='';
      this.elements = ['Master Bedroom','Kids Room', 'Wardrobe'];
      this.lifestageFlag = false;
      this.elementsFlag = true;
      this.theme = "";
    }
    else if(val == 'Living'){
      this.lifestage='';
      this.theme = "";
      this.themes = ['Minimalist','Transitional','Contemporary','Modern','Rustic Industrial','Indian Ethnic','Other'];
      this.element='';
      this.lifestageFlag = false;
      this.elementsFlag = false;
    } 
    else if(val == 'Kids Room'){
      this.lifestage='';
      this.theme = "";
      this.themes = ['Minimalist','Transitional','Contemporary','Modern','Rustic Industrial','Indian Ethnic','Other'];
      this.element='';
      this.lifestageFlag = false;
      this.elementsFlag = false;
    }
    else {
      this.lifestage ='';
      this.element ='';
    }
    this.getSpaceItems(val);
    this.selected_space_item = [];
    this.space_item = []
  }

  themeDropDownChanged(val:any,i:number){
    if(val=='Lifestage Kitchen') {
      this.lifestageFlag[i] = true;
    } else {
      this.lifestageFlag[i] = false;
    }
  }
  searchstring:any;
  totalpage:any;
  total_page:any;
  pagination:any;
  perpage:any =10;
  getPageNumber(event){
    this.current_page = event;
    this.pagination = event;
    // this.getpage()
   
  }
  getpage(event: any){
    this.current_page = event;
    if(this.current_page == undefined){
      this.current_page = 1;
    }
   
    if(this.searchstring == undefined){
      this.searchstring = '';
    }
    this.loaderService.display(true);
    this.portfolioService.getPortfolioListof(this.searchstring,this.current_page,this.perpage).subscribe(res=>{
      let portfolio = JSON.parse(res._body);
      this.total_page = portfolio.count;
      this.current_page = portfolio.page_number
       this.portfolio = portfolio.portfolios ;
       this.loaderService.display(false);
       
    },
    err=>{
      this.loaderService.display(false);
    })
  }
  
  
 
  onChange(event) {
    this.attachment_File = event.srcElement.files[0];
    var fileReader = new FileReader();
    var base64;
    fileReader.onload = (fileLoadedEvent) => {
      base64 = fileLoadedEvent.target;
      this.basefile = base64.result;
    };
    fileReader.readAsDataURL(this.attachment_File);
  }

  attachment_file_secondary: any;
  attachement_files = [];
  imageNamess = [];
  onChangeSecondary(event) {
    if (event.target.files && event.target.files[0]) {
      var filesAmount = event.target.files.length;
      for (let i = 0; i < filesAmount; i++) {
        var reader = new FileReader();
        var base64;
        reader.onload = (fileLoadedEvent) => {
          var image = new Image();
          base64 = fileLoadedEvent.target;
                
                 this.attachement_files.push(base64.result); 
        }
        reader.readAsDataURL(event.target.files[i]);
        // this.imageNamess.push(event.target.files[i].name);
      }

  }
   
  }

  finalVarient: any = [];
  onSubmit(data) {
   $('#exampleModalLong').modal('hide');
    this.loaderService.display(true);
    this.imgsrc = "";
    data.attachment_file = this.basefile;
    data.attachment_file_secondary = this.attachement_files;
    if (this.xyz.length === 0) {
      this.finalVarient = this.varientIdimage;
    }
    else if (this.xyz.length === undefined) {
      this.finalVarient = this.xyz;
    }
    let obj = {
      portfolio: {
        'segment': data.segment,
        'theme': (data.segment == 'Home' && (data.space == 'Living') || (data.space == 'Kitchen') || (data.space == 'Kids Room')) ? data.theme : '',
        'element': (data.segment == 'Home' && data.space == 'Bedroom') ? data.element : '',
        'space': data.space,
        'attachment_file': data.attachment_file,
        'lifestage': data.lifestage,
        'price_cents': data.price_cents,
        'preset_number': data.preset_number,
        'preset_type' :data.preset_type,
        'space_area': data.space_area,
        'space_shape': data.space_shape,
        'contents': data.attachment_file_secondary,
        'apartments': [this.finalVarient],
        'boq_value': this.boq_value,
        'boq_number': data.boq_number,
        'description': data.description,
        'user_story_title' : data.user_story_title,
        'portfolio_data' : (data.portfolio_data!="" && data.portfolio_data!=null && 
           data.portfolio_data != undefined && data.portfolio_data != "NA") ? (data.portfolio_data) : '',
        'space_items': this.selected_space_item.length > 0 ? this.selected_space_item : this.space_item
       }
     }
    this.submitted = true;
    this.portfolioService.editPortfolio(this.finalid,obj)
    .subscribe(
        res => {
         this.portfolioListFromService();
         this.loaderService.display(false);
         this.successalert = true;
         this.basefile = undefined;
        this.successMessage = "Portfolio Updated Successfully !!";
        this.imageNamess = [];
        this.attachement_files = [];
         setTimeout(function() {
               this.successalert = false;
           }.bind(this), 2000);
         //$.notify('Updated Successfully!');
        },
        error => {
           this.loaderService.display(false);
           this.erroralert = true;
           this.errorMessage = JSON.parse(error['_body']).message;
           setTimeout(function() {
                 this.erroralert = false;
             }.bind(this), 2000);
          //$.notify(JSON.parse(error['_body']).message);
        }
    );
  }
  tooltipHide(){
    $('.add').tooltip('hide')
  }


  transform(value: string): string {
    return value.replace(/_/g, ' ');
  }

  selected_space_item: any = [];
  isAllSelected(e, i) {
    if (e.target.checked) {
      this.selected_space_item.push(parseInt(e.target.value))
    }
    else {
      const index =  this.selected_space_item.indexOf(parseInt(e.target.value));
      if (index > -1) {
        this.selected_space_item.splice(index, 1);
      }
    }
    
  }

  lifeStage: any;
  getLifeSatgeData() {
    this.portfolioService.getLifeStage().subscribe(
      res=>{
        this.lifestages = res;
      },
      err=>{
        this.loaderService.display(false);
      }
    );
  }

  other_space_item:any = []
  getSpaceItems(val) {
    this.portfolioService.getOther(val).subscribe(
      res=>{
        this.other_space_item = [];
        // this.other_space_item = res.data;
        for (let i = 0; i < res.data.length; i++){
          
          const a = this.selected_space_item.indexOf(parseInt(res.data[i].attributes.id));
          if (a == -1) {
            this.other_space_item.push(res.data[i].attributes)
          }
        }
        
      },
      err=>{
        this.loaderService.display(false);
      }
    );
  }

  selectLifeStage(val){
    this.lifestage = val;
    
  }

  // boq_reference_number_value: any;
  boq_dropdown: any;
  getBOQvalues(event: any) {
    this.boq_number = event;
    if (this.boq_number === undefined) {
      this.boq_number = ''
    }
    this.portfolioService.getBoqValues(this.boq_number).subscribe(
      res => {
        this.boq_dropdown = res;
        
      }
    )
  }

  searchBOQ(event: any) {
    let searchWord = event.target.value;
    this.getBOQvalues(searchWord);
  }
  BOQAmount: any;
  getsBOQnumber(event: any) {
  this.boq_number = event;
  let obj = this.boq_dropdown.find( (elem:any) => elem.reference_number ===  this.boq_number);
  this.boq_value = obj.total_amount;
    
  }

  getCities() {
    this.portfolioService.getCities().subscribe(res => {
      this.city_list = res.cities;
      
      
    })
  }
  selectedCity: any;
  getscityList(event: any) {
    this.selectedCity=event;
   this.societySearch(this.selectedCity,this.search);
  }

  searchSociety(event:any) {
    let searchWord = event.target.value;
    this.societySearch(this.selectedCity,searchWord)
  }

  selectedBuilding:any;
  getselectedbuilding(event: any) {
  this.selectedBuilding = event;
  let obj = this.societyList.find( (elem:any) => elem.id ===  this.selectedBuilding);
  // this.buildingName = obj.building_name;
 this.flatsizeType(event) ;
  }
  searchCity(event: any) {
    let searchcity = event.target.value;
  }
  
  flatsize:any;
storesize:any;
  flatsizeType(id: any) {
    this.portfolioService.flatsizetype(id).subscribe(data => {
      this.format = '';
      this.variant_id = '';
     this.storesize= data; 
    this.flatsize = this.storesize.varients;
    // this.getVarientDetaisls();
  })
  } 

  societyList = [];
  societySearch(city_name, search) {
    this.portfolioService.getLocalityBuildingDetails(city_name, search).subscribe(
      res => {
        this.societyList = res.data;
        
        if (this.societyList.length === 0) {
          this.xyz = '';
        }
      },
      err => {
      }
    );
  }
  selectedBuildingtype: any;
  areaType: any;
  getselectedbuildingtypes(event: any) {
    this.selectedBuildingtype = event;
    
    this.getVarientDetaisls();
   let obj = this.flatsize.find( (elem:any) => elem.area ===  this.selectedBuildingtype);
    this.areaType = obj.type;
    this.getVarientDetaisls();
  }

  varientId: any;
  getVarientDetaisls() {
    if (this.selectedBuildingtype === undefined) {
      this.selectedBuildingtype = ''
    }
    this.portfolioService.getVarientDetails(this.selectedBuilding, this.selectedBuildingtype).subscribe(
      res => {
        
        this.varientId = res;
      }
    )
  }

  xyz: any = [];
  isAllVarient(e) {
    this.xyz = e;
    
  }

  deleteContent(id: any) {
    alert('Are You Sure?');
    this.portfolioService.deletePortfolioContent(id).subscribe(portfolio => {
      // this.successalert = true;
      alert("Content Deleted Successfully !!");
      // $('#exampleModalLong').modal('hide');
      this.getPortfolio(this.finalid);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/platform/organisation/portfolio/listportfoliodata/listportfoliodata.component.ts